import { ContentService } from '@blk/cwp-ng-framework';

import { Formatter } from './formatter.interface';
import { NumberFormatter } from './number-formatter';

const BILLION_AMOUNT = 9;
const MILLION_AMOUNT = 6;
const THOUSAND_AMOUNT = 3;
const BILLION_SUFFIX = 'b';
const MILLION_SUFFIX = 'm';
const THOUSAND_SUFFIX = 'k';
export class NumberWithUnitsFormatter implements Formatter {
	/******************************************************************************************************
	setting skipDecimalForThousands to true - when you don't need any decimal places for values in thousands
	last leading value will be rounded off based on the trailing values
	e.g. 345678 will be converted to 346k, 123456 will change to 123k 
	*******************************************************************************************************/
	constructor(public readonly defaultNullValue?: string, public readonly defaultUndefinedValue?: string, public skipDecimalForThousands: boolean = false) { }

	public format(value: any, contentSvc?: ContentService): string {
		if (value === null) {
			return this.defaultNullValue || NumberFormatter.NOT_APPLICABLE;
		}

		if (value === undefined) {
			return this.defaultUndefinedValue || NumberFormatter.DASH_VALUE;
		}

		if (typeof value === 'string' && !isNaN(Number(value))) {
			if (value === '') {
				return this.defaultUndefinedValue || NumberFormatter.DASH_VALUE;
			}
			value = Number(value);
		}

		if (typeof value === 'number') {
			let valueAsString = value.toString();
			// this shouldn't be the case but let's test for it in case
			if (valueAsString.indexOf('.') > -1) {
				valueAsString = valueAsString.split('.')[0];
			}
			let trailingAmount: number;
			let suffix: string = '';

			if (valueAsString.length > BILLION_AMOUNT) {
				trailingAmount = BILLION_AMOUNT;
				suffix = BILLION_SUFFIX;
			} else if (valueAsString.length > MILLION_AMOUNT) {
				trailingAmount = MILLION_AMOUNT;
				suffix = MILLION_SUFFIX;
			} else if (valueAsString.length > 3) {
				trailingAmount = THOUSAND_AMOUNT;
				suffix = THOUSAND_SUFFIX;
				if (this.skipDecimalForThousands) {
					valueAsString = parseFloat((value / 1000).toFixed(0)) + suffix;
					return valueAsString;
				}
			} else {
				return valueAsString;
			}

			const leadingValue = valueAsString.slice(0, valueAsString.length - trailingAmount);
			let trailingValue = valueAsString.slice(valueAsString.length - trailingAmount);

			if (trailingValue) {
				trailingValue = `.${trailingValue}`;
				const trailingValueAsDecimal = parseFloat(trailingValue).toFixed(1);
				if (parseFloat(trailingValueAsDecimal) > 0) {
					const combinedValue = (parseFloat(leadingValue) + parseFloat(trailingValueAsDecimal)).toFixed(1);
					return `${combinedValue}${suffix}`;
				}
			}
			return leadingValue + suffix;
		} else {
			return this.defaultNullValue || NumberFormatter.NOT_APPLICABLE;
		}
	}
}
